<template>
  <b-modal
    id="employee-group-edit-modal"
    footer-bg-variant="light"
    :title="groupName"
    :size="size"
  >
    <b-tabs
      pills
      nav-class="nav-primary"
      v-model="tab"
      @activate-tab="changeModalSize"
    >
      <b-tab :title="this.$t('GROUP.SCHEDULE.TABGENERAL')" lazy>
        <TeacherGroupEditForm class="m-2 mt-3 p-2"></TeacherGroupEditForm>
      </b-tab>

      <b-tab :title="this.$t('GROUP.SCHEDULE.BASE')" lazy>
        <TeacherGroupSchedule class="m-2 mt-3 p-2"></TeacherGroupSchedule>
      </b-tab>
    </b-tabs>

    <template #modal-footer="{ ok, cancel }">
      <b-button variant="light" class="btn-hover-danger" @click="cancel"
        >{{ $t("BUTTON.CANCEL") }}
      </b-button>

      <b-button
        variant="primary"
        v-if="tab === 0"
        v-bind:class="{
          'spinner spinner-light spinner-right': getHeldTeacherEditGroup,
        }"
        v-on:click="updateGroup"
      >
        {{ $t("GROUP.UPDATE") }}
      </b-button>

      <b-button
        variant="primary"
        v-if="tab === 1"
        v-bind:class="{
          'spinner spinner-light spinner-right': getHeldTeacherGroupSchedule,
        }"
        v-on:click="saveSchedule"
        >{{ $t("GROUP.SAVE") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import TeacherGroupEditForm from "@/modules/school/components/teacher/group/TeacherGroupEditForm";
import { mapGetters } from "vuex";
import TeacherGroupSchedule from "@/modules/school/components/teacher/group/schedule/TeacherGroupSchedule";

export default {
  name: "TeacherGroupModal",
  components: {
    TeacherGroupSchedule,
    TeacherGroupEditForm,
  },
  data: function () {
    return {
      size: "md",
      isBusy: false,
      tab: 0,
    };
  },
  methods: {
    saveSchedule() {
      console.log("Emitting schedule save event..");
      this.$store.dispatch("engageTeacherGroupFormSubmission");
    },
    changeModalSize(newTabIndex) {
      console.log(newTabIndex);
      switch (newTabIndex) {
        case 0:
          this.size = "md";
          break;
        case 1:
          this.size = "xl";
          break;
        default:
          break;
      }
    },
    updateGroup() {
      console.log("Emitting teacher group update event..");
      this.$store.dispatch("engageUpdateTeacherGroupForm");
    },
  },
  computed: {
    groupName() {
      return this.$store.getters.getTeacherGroupInformation.name + " Group";
    },
    ...mapGetters([
      "getTeacherGroupInformation",
      "getHeldTeacherGroupSchedule",
      "getHeldTeacherEditGroup",
    ]),
    ...mapGetters({
      editIsBusy: "getHeldTeacherEditGroup",
      scheduleIsBusy: "getHeldTeacherGroupSchedule",
    }),
  },
};
</script>

<style scoped></style>
